import axios from 'axios'
import { useState } from 'react'
import { QueryClient, QueryCache, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import { ErrorBoundary } from './components/ErrorBoundary'
import Toaster from './components/ui/Toaster'

export default function App() {
  const [apiError, setApiError] = useState<string | null>(null)

  const [queryClient] = useState(() => new QueryClient({
    queryCache: new QueryCache({
      onError: (error) => {
        if (!axios.isAxiosError(error)) return
        if (!error.response) {
          setApiError('Connection error — check your internet and try again.')
        } else if (error.response.status >= 500) {
          setApiError('Server error — some data may not have loaded. Try refreshing.')
        }
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: (failureCount, error) => {
          if (axios.isAxiosError(error) && error.response?.status === 401) return false
          return failureCount < 1
        },
      },
    },
  }))

  return (
    <ErrorBoundary>
      {apiError && (
        <div className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between bg-red-50 border-b border-red-200 px-4 py-2.5">
          <span className="text-sm text-red-700">⚠️ {apiError}</span>
          <button
            onClick={() => setApiError(null)}
            className="ml-4 text-red-400 hover:text-red-600 text-xl font-light leading-none"
            aria-label="Dismiss"
          >
            ×
          </button>
        </div>
      )}
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <Toaster />
      </QueryClientProvider>
    </ErrorBoundary>
  )
}

